import React, { useEffect, useState } from 'react';
import Recipe from './recipe';
import './App.css';

function App() {

  const APP_ID = "c67b7d9e";
  const APP_KEY = "edf677d86d4c5e6187a5e90a91b20475"

  const [recipes, setrecipes] = useState([]);
  const [search, setsearch] = useState('');
  const [query, setquery] = useState('chicken');

  useEffect(() => {
    getRecipes();
    console.log("We are Fetching Data");
  }, [query]);

  const getRecipes = async () => {
    const response = await fetch(
      `https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${APP_KEY}`);
    const data = await response.json();
    setrecipes(data.hits);
    console.log(data.hits);
  }

  const updatesearch = e => {
    setsearch(e.target.value);
  }

  const getsearch = e => {
    e.preventDefault();
    setquery(search);
    setsearch('');
  }

  return (
    <div className="App">
      <h1 className="logo">Frecipe</h1>
      <div className="logobottom">
        <div className="line"></div><p className="logo-des">Get Delicious Recipies</p><div className="line"></div>
      </div>
      <form className="search-form" onSubmit={getsearch} >
        <input type="search" placeholder="Search Recipes" className="search-bar" value={search} onChange={updatesearch} />
        <button className="search-btn" type="submit">Search</button>
      </form>
      <div className="recipies">
        {recipes.map(recipe => (
          <Recipe
            key={recipe.recipe.label}
            title={recipe.recipe.label}
            calories={recipe.recipe.calories}
            image={recipe.recipe.image}
            ingredients={recipe.recipe.ingredients}
          />
        ))}
      </div>
    </div>
  );
}

export default App;